<template>
  <div class="top">
    <!--    这里注意设置轮播高度和图片高度一致-->
    <el-carousel
      :interval="during"
      :height="setHeight"
       type="card"
      :class="isBg ? 'setBg' : ''"
    >
      <el-carousel-item v-for="(item, index) in imgUrl" :key="index">
        <div class="wei">
          <div class="left-tips" v-if="item.description">
            <div class="line">
              <label>产品款式:{{ item.description.product }}</label>
            </div>
            <div class="line">
              <label>产品尺寸:{{ item.description.size }}</label>
            </div>
            <div class="line">
              <label>出轴长:{{ item.description.zhou }}</label>
            </div>
            <div class="line">
              <label>轴径:{{ item.description.pie }}</label>
            </div>
            <div class="line">
              <label>保持转矩:{{ item.description.support }}</label>
            </div>
          </div>
          <img class="iso" :src="item.extra" />
          <img class="big" :src="item.img" alt="" />
        </div>

        <div class="tips">{{ item.title }}</div>
        <div class="xiang" v-if="isBg">
          <img src="../../assets/swiperProduct/006.png" />
        </div>
        <slot></slot>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "Swiper",
  props: {
    imgUrl: {
      typeof: Array,
      default: () => [],
    },
    during: {
      typeof: String,
    },
    isBg: {
      typeof: Boolean,
      default: false,
    },
    setHeight: "",
  },
  data() {
    return {
      carouselHeight: "700px",
      screenWidth: 0,
    };
  },
  created() {
    this.screenWidth = localStorage.getItem("screenWidth");
    this.updateCarouselHeight();
  },
  methods: {
    updateCarouselHeight() {
      if (this.screenWidth <= 768) {
        this.carouselHeight = "200px"; // Adjust the height as needed
      } else {
        // this.carouselHeight = '500px'; // Default height
      }
    },
  },
};
</script>

<style scoped>
.el-carousel__item {
  text-align: center;
  /* padding-top: 80px; */
}
.setBg {
  background: url("../../assets/swiperProduct/013.png") no-repeat;
  /* background-size: 100% 100%; */
  background-size: cover;
  font-size: 24px;
}
.el-carousel__item:nth-child(2n) {
  /* background-color: #99a9bf; */
}

.el-carousel__item:nth-child(2n + 1) {
  /* background-color: #d3dce6; */
}
.tips {
  margin-top: 30px;
  display: flex;
  height: 40px;
  font-size: 30px;
  font-weight: bold;
  justify-content: center;
  align-items: center;
}
.xiang {
  display: flex;
  height: 30px;
  justify-content: center;
  align-items: center;
}
.top .wei {
  position: relative;
}
.left-tips {
  position: absolute;
  top: 13%;
  left: 32%;
}
.line {
  display: flex;
  font-size: 15px;
  height: 23px;
  align-items: center;
}
.iso {
  position: absolute;
  top: 13%;
  right: 20%;
}
.top .big {
  margin-top: 100px;
 height: 300px;
}
.top {
  width: 100%;
}
</style>
